import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, showUnselectedOptions = true,
    outdoorSpacesOther, indoorSpacesOther, PracticalAmenitiesOther, standoutAmenitiesOther, ecoFriendlyAmenitiesOther,
    familyAmenitiesOther,
    safetyAmenitiesOther, } = props;
  const removeOther = selectedOptions.filter(
    item => item !== 'other'
  );
  const hasContent = showUnselectedOptions || removeOther?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      {removeOther.length > 0 ?
        <PropertyGroup
          id="ListingPage.amenities"
          options={options}
          selectedOptions={removeOther}
          indoorSpacesOther={indoorSpacesOther}
          outdoorSpacesOther={outdoorSpacesOther}
          PracticalAmenitiesOther={PracticalAmenitiesOther}
          standoutAmenitiesOther={standoutAmenitiesOther}
          ecoFriendlyAmenitiesOther={ecoFriendlyAmenitiesOther}
          familyAmenitiesOther={familyAmenitiesOther}
          safetyAmenitiesOther={safetyAmenitiesOther}
          twoColumns={options.length > 5}
          showUnselectedOptions={showUnselectedOptions}
        />
        :
        "No data added"}
    </section>
  );
};

export default SectionMultiEnumMaybe;
